import {useEffect as $g7Czo$useEffect} from "react";
import {useToggle as $g7Czo$useToggle} from "@react-aria/toggle";
import {filterDOMProps as $g7Czo$filterDOMProps, mergeProps as $g7Czo$mergeProps} from "@react-aria/utils";
import {useLabel as $g7Czo$useLabel} from "@react-aria/label";
import {useToggleState as $g7Czo$useToggleState} from "@react-stately/toggle";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $fea2f35efc29884c$exports = {};

$parcel$export($fea2f35efc29884c$exports, "useCheckbox", () => $fea2f35efc29884c$export$e375f10ce42261c5);


function $fea2f35efc29884c$export$e375f10ce42261c5(props, state, inputRef) {
    let { inputProps: inputProps  } = $g7Czo$useToggle(props, state, inputRef);
    let { isSelected: isSelected  } = state;
    let { isIndeterminate: isIndeterminate  } = props;
    $g7Czo$useEffect(()=>{
        // indeterminate is a property, but it can only be set via javascript
        // https://css-tricks.com/indeterminate-checkboxes/
        if (inputRef.current) inputRef.current.indeterminate = isIndeterminate;
    });
    return {
        inputProps: {
            ...inputProps,
            checked: isSelected,
            'aria-checked': isIndeterminate ? 'mixed' : isSelected
        }
    };
}


var $ec288cd435d5d49a$exports = {};

$parcel$export($ec288cd435d5d49a$exports, "useCheckboxGroup", () => $ec288cd435d5d49a$export$49ff6f28c54f1cbe);
const $61350709ee325005$export$31440636951aa68c = new WeakMap();




function $ec288cd435d5d49a$export$49ff6f28c54f1cbe(props, state) {
    let { isDisabled: isDisabled , name: name  } = props;
    let { labelProps: labelProps , fieldProps: fieldProps  } = $g7Czo$useLabel({
        ...props,
        // Checkbox group is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: 'span'
    });
    let domProps = $g7Czo$filterDOMProps(props, {
        labelable: true
    });
    // Pass name prop from group to all items by attaching to the state.
    $61350709ee325005$export$31440636951aa68c.set(state, name);
    return {
        groupProps: $g7Czo$mergeProps(domProps, {
            role: 'group',
            'aria-disabled': isDisabled || undefined,
            ...fieldProps
        }),
        labelProps: labelProps
    };
}


var $a84307d0769c22d8$exports = {};

$parcel$export($a84307d0769c22d8$exports, "useCheckboxGroupItem", () => $a84307d0769c22d8$export$353b32fc6898d37d);



function $a84307d0769c22d8$export$353b32fc6898d37d(props, state, inputRef) {
    const toggleState = $g7Czo$useToggleState({
        isReadOnly: props.isReadOnly || state.isReadOnly,
        isSelected: state.isSelected(props.value),
        onChange (isSelected) {
            if (isSelected) state.addValue(props.value);
            else state.removeValue(props.value);
            if (props.onChange) props.onChange(isSelected);
        }
    });
    let { inputProps: inputProps  } = $fea2f35efc29884c$export$e375f10ce42261c5({
        ...props,
        isReadOnly: props.isReadOnly || state.isReadOnly,
        isDisabled: props.isDisabled || state.isDisabled,
        name: props.name || $61350709ee325005$export$31440636951aa68c.get(state)
    }, toggleState, inputRef);
    return {
        inputProps: inputProps
    };
}




export {$fea2f35efc29884c$export$e375f10ce42261c5 as useCheckbox, $ec288cd435d5d49a$export$49ff6f28c54f1cbe as useCheckboxGroup, $a84307d0769c22d8$export$353b32fc6898d37d as useCheckboxGroupItem};
//# sourceMappingURL=module.js.map
